export default __webpack_public_path__ + "static/media/pharos_logoHorizontal_Retina_alpha.3fd0f945.png";